import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import type { SetSlideState } from '@mentimeter/question-modules-types';
import type { SlideStateOpen } from '../../slide-state';

export const useOpenSlideState: () => [
  SlideStateOpen,
  SetSlideState<SlideStateOpen>,
] = () => {
  const { useSlideState } = usePresentationContext();
  const [slideState, setSlideState] = useSlideState<SlideStateOpen>();

  return [slideState, setSlideState];
};
